import { useContext, useEffect, useState } from 'react'
import { Box, DialogContent, CircularProgress, Tooltip } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import IconeChatGPT from "../../Assets/icones/iconeChatGPT"
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import OneModal from '../../Components/OneModal/OneModal'
import OneButton from '../OneButton/OneButton'
import { useAppTheme } from '../../Providers/ThemeContext/ThemeContext'
import { CheckCircleOutline, HighlightOff } from '@mui/icons-material'
import { showNotify } from "../../Utils/Utils"
import { UserContext } from '../../Providers/UserContext/UserContex'
import chatgpt from '../../Assets/icones/chatgpt.svg'
import chatgptDisable from '../../Assets/icones/chatgpt-disabled.svg'

export const OneChatGPTComponente = ({
    value,
    evento,
    hashtags,
    mensagemGPT
}) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { user } = useContext(UserContext)

    const [openChatModal, setOpenChatModal] = useState(false)
    const [respostaChat, setRespostaChat] = useState('')
    const [tempoResposta, setTempoResposta] = useState('')
    const [loadingState, setLoadingState] = useState(false)
    const [ativo, setAtivo] = useState(null)

    const { theme } = useAppTheme()

    useEffect(() => {
        setAtivo(global.chatgpt_ativo && evento.id && evento.usuario_tratando && user.id == evento.usuario_tratando.id)
    }, [evento])

    const chatGPTCallback = async () => {
        if (!user || !evento || !evento.usuario_tratando || user.id != evento.usuario_tratando.id) { // Se o evento selecionado não for do usuario logado
            return false
        }

        const data = value
        let hashtag = ""
        if (evento && evento.id_hashtag) {
            hashtag = hashtags.find(tag => tag.id == evento.id_hashtag)
        }

        const mensagem = {
            data: evento.data,
            evento: `${evento.evento} - ${evento.descricao}`,
            cliente: `${evento.id_central} - ${evento.condominio}`,
            procedimentos: evento.procedimento,
            tag: hashtag.descricao,
            interação: data
        }
        sendWs('GPT', {
            functionName: "corretor",
            forChat: mensagem
        })
        setLoadingState(true)
        addRoute('GPT', Modal)
        setTimeout(() => {
            if (loadingState) {
                Modal({ data: { status: false, mensagemChat: 'Tempo de resposta excedido' } })
                addRoute('GPT', null)
            }
        }, 20000)
    }
    const Modal = (msg) => {
        if (msg.data.status) {
            setOpenChatModal(true)
            setLoadingState(false)
            setRespostaChat(msg.data.mensagemChat)
            setTempoResposta(msg.data.tempoRequisicao)
        } else {
            if (msg.data.mensagemChat.includes('timeout')) {
                showNotify('error', 'Tempo de resposta excedido', {
                    position: 'bottom-right'
                })
            } else {
                showNotify('error', msg.data.mensagemChat, {
                    position: 'bottom-right'
                })
            }
            setLoadingState(false)
        }
    }
    const handleFecharModal = (status) => {
        setOpenChatModal(status)
    }

    const handleAceitou = () => {
        handleClick(respostaChat, tempoResposta, evento, 'aceitou')
    }

    const handleRecusou = () => {
        handleClick(respostaChat, tempoResposta, evento, 'recusou')
    }

    const handleClick = (msg, tempo, evento, resposta) => {
        const textoAceite = `O(A) colaborado(a) ${evento.usuario_tratando.nome} aceitou a sugestão gerada pelo ChatGPT, que respondeu em ${tempo}, e o texto retornado pela Inteligência Artificial foi:
        ${msg}`

        const textoRecusa = `O(A) colaborado(a) ${evento.usuario_tratando.nome} recusou a sugestão gerada pelo ChatGPT, que respondeu em ${tempo}`

        switch (resposta) {
            case 'aceitou':
                sendWs('gravarHistorico', {
                    id: evento.id,
                    historico: textoAceite
                })
                mensagemGPT(msg)
                break
            case 'recusou':
                sendWs('gravarHistorico', {
                    id: evento.id,
                    historico: textoRecusa
                })
                break
        }
        handleFecharModal(false)
    }

    const loading = (
        <Box
            sx={{
                display: 'flex',
                width: "28px",
                height: '28px',
                position: "absolute",
                zIndex: 90,
                marginTop: "-30px"
            }}
        >
            <CircularProgress size={20} sx={{ color: theme.palette.one_primary.main }} />
        </Box>
    )

    const componenteRenderiza = () => (
        <>
            {loadingState
                ? (
                    loading
                )
                : ativo
                    ? <Tooltip title="Assistente IA" placement="bottom" arrow>
                        <img
                            style={{
                                height: "28px",
                                width: "38px",
                                cursor: "pointer",
                                zIndex: 90,
                                marginTop: "-32px",
                                borderRadius: "10px"
                            }}
                            src={chatgpt}
                            onClick={() => {
                                global.chatgpt_ativo
                                    ? evento.id
                                        ? evento.usuario_tratando && user.id == evento.usuario_tratando.id
                                            ? chatGPTCallback()
                                            : showNotify('warning', 'Você não pode utilizar o ChatGPT em um evento que não está tratando', {
                                                position: 'bottom-right'
                                            })
                                        : showNotify('warning', 'Selecione um evento para utilizar o ChatGPT', {
                                            position: 'bottom-right'
                                        })
                                    : showNotify('warning', 'Entre em contato com o comercial para ativar essa funcionalidade.', {
                                        position: 'bottom-right'
                                    })
                            }}

                        />
                    </Tooltip>
                    : <img
                        style={{
                            height: '29px',
                            width: '39px',
                            zIndex: 90,
                            marginTop: "-32px"
                        }}
                        src={chatgptDisable}
                    />
            }
            {openChatModal && (
                <OneModal
                    open={openChatModal}
                    titleText="Log de sistema sugerido pelo ChatGPT"
                    fullWidth={true}
                    TitleIcon={() => <IconeChatGPT
                        renderText={false}
                        style={{
                            width: "100%",
                            height: "28px",
                            position: "absolute",
                            paddingLeft: '120px'
                        }}
                    />}
                    setOpen={setOpenChatModal}
                    maxWidth='sm'
                    loading={loadingState}
                    FooterButtons={() => <FooterButtons handleAceitou={handleAceitou} handleRecusou={handleRecusou} /> }
                >
                    <Grid>
                        {/* <Grid sx={invisibleDiv} onClick={() => handleFecharModal(false)}/> */}
                        <Grid container sx={{ justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                            <pre style={{ margin: '10px', whiteSpace: 'pre-wrap' }}>{respostaChat}</pre>
                        </Grid>
                        <DialogContent
                            style={{
                                paddingTop: '15px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column'
                            }}>
                        </DialogContent>
                    </Grid>
                </OneModal>
            )}
        </>
    )

    return (
        // global.chatgpt_ativo && (
        <>
            {componenteRenderiza()}
        </>
        // )
    )
}

export const FooterButtons = ({ handleAceitou, handleRecusou }) => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', gap: '5px', width: '100%' }}>
            <Box sx={{ paddingLeft: '5px' }}>
                <Box sx={{ fontSize: "12px", color: 'black' }}><b>Versão de demonstração</b></Box>
            </Box>
            <Box sx={{ alignItems: 'center', justifyContent: 'flex-end', gap: '5px' }}>
                <OneButton
                    variant="contained"
                    color="error"
                    IconStart={HighlightOff}
                    sxIconStart={{ width: '20px' }}
                    onClick={handleRecusou}
                    // disabled={disabledButtons("obs")}
                >
                    <span style={{ fontSize: '13px', marginLeft: '3px' }}
                    >
                        Recusar
                    </span>
                </OneButton>
                <OneButton
                    variant="contained"
                    color="success"
                    IconStart={CheckCircleOutline}
                    sxIconStart={{ width: '20px' }}
                    onClick={handleAceitou}
                    // disabled={disabledButtons("obs")}
                >
                    <span style={{ fontSize: '13px', marginLeft: '3px' }}
                    >
                        Aceitar
                    </span>
                </OneButton>

            </Box>
        </Grid>
    )
}
